import { c as _c } from "react/compiler-runtime";
import { useHasUserValidRoleGroupLevel } from "@hooks/access-control/use-has-user-valid-role-group-level";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
/**
 * Returns what the current user may do with the members of a group. The role column and the 3-dot
 * menu both ask here, so that they offer the same actions.
 *
 * Changing a role needs the permission to edit the members of the group, held by its managers and
 * workspace admins, and a plan that can assign managers. Group managers cannot change their own
 * role, as they might lose access to the group.
 *
 * @param group The group, or nothing while it is not loaded
 */
export function useGroupMemberActions(group) {
  const $ = _c(6);
  const currentUser = useAppSelector(currentUserSelector);
  const t0 = group ?? null;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      selectedGroup: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    canEditMember
  } = useHasUserValidRoleGroupLevel(t1);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const canChangeRoles = !!group && canEditMember && canAssignManagers;
  const isCurrentUserGroupManager = currentUser?.role === "COMPANY_MANAGER";
  let t2;
  if ($[2] !== canChangeRoles || $[3] !== currentUser?.identity || $[4] !== isCurrentUserGroupManager) {
    t2 = {
      canChangeRole: member => canChangeRoles && !(isCurrentUserGroupManager && member.identity === currentUser?.identity)
    };
    $[2] = canChangeRoles;
    $[3] = currentUser?.identity;
    $[4] = isCurrentUserGroupManager;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}